import { useAppSelector } from '@/hooks/redux-hooks';
import type { TimeDifference } from '@/utils/getTimeDifference';

const useTimeToExpire = (): TimeDifference | undefined =>
  useAppSelector(state => state.user.timeToExpire);

export default useTimeToExpire;
